import { render, staticRenderFns } from "./androidIcon.vue?vue&type=template&id=bfdc3224&"
import script from "./androidIcon.vue?vue&type=script&lang=js&"
export * from "./androidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports